import { render, staticRenderFns } from "./ProjectHero.vue?vue&type=template&id=38c84209&"
import script from "./ProjectHero.vue?vue&type=script&lang=js&"
export * from "./ProjectHero.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/northbankcm/public_html/frontend/components/modules/Video.vue').default,ResponsiveImageStrapi: require('/home/northbankcm/public_html/frontend/components/modules/ResponsiveImageStrapi.vue').default})
